export default "__VITE_ASSET__BTXOKKqD__"